var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4583 13.2476H3.625C2.93333 13.2476 2.375 12.6892 2.375 11.9976V4.49756C2.375 3.80589 2.93333 3.24756 3.625 3.24756H14.4583C15.15 3.24756 15.7083 3.80589 15.7083 4.49756V11.9976C15.7083 12.6892 15.15 13.2476 14.4583 13.2476ZM3.625 4.08089C3.39167 4.08089 3.20833 4.26423 3.20833 4.49756V11.9976C3.20833 12.2309 3.39167 12.4142 3.625 12.4142H14.4583C14.6917 12.4142 14.875 12.2309 14.875 11.9976V4.49756C14.875 4.26423 14.6917 4.08089 14.4583 4.08089H3.625Z",
    fill: "#861DF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04054 9.88091C8.45721 9.88091 7.92388 9.64758 7.52388 9.22258L3.14888 4.57258C2.99054 4.40591 2.99888 4.13924 3.16554 3.98091C3.33221 3.82258 3.59888 3.83091 3.75721 3.99758L8.13221 8.64758C8.60721 9.15591 9.47388 9.15591 9.94888 8.64758L14.3239 4.00591C14.4822 3.83924 14.7489 3.83091 14.9155 3.98924C15.0822 4.14758 15.0905 4.41424 14.9322 4.58091L10.5572 9.23091C10.1572 9.65591 9.62388 9.88924 9.04054 9.88924V9.88091Z",
    fill: "#861DF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ae4aa13cccb0e4ef235bb23f269de4e2.svg";
export { ForwardRef as ReactComponent };